export default __webpack_public_path__ + "static/media/Days_03.d8b6feaf.png";